import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormField from '../../forms/_common/FormField';
import { OutlineButton } from '../../@communityshare/ui/Button';
import { SolidButton } from '../../@communityshare/ui/Button';
import TextAreaField from '../../forms/_fields_v2/TextAreaField';
import FormTemplate from '../../dialogs_common/FormTemplate';
import { ClockIcon } from '@heroicons/react/24/outline';
import { useConnect } from '@lore/query-connect';
import moment from 'moment-timezone';
import MessageDeliveryStatus from '../../components/MessageDeliveryStatus';
import { PayloadStates } from '@lore/utils';
import { useUser } from '@lore/auth';
import Users from './Users';
import StringField from '../../forms/_fields_v2/StringField';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';

Form.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onSubmit,
    onClose
  } = props;

  return (
    <FormTemplate
      textAlign="left"
      title={`Invite a new staff member?`}
      subtitle={(
        <span>
          Enter the email address of the user account that you want to have staff access.
        </span>
      )}
      // showIcon={false}
      // icon={ClockIcon}
      onClose={onClose}
      alert={alert}
      body={(
        <>
          <FormField name="email" data={data} errors={showErrors && errors} onChange={onChange}>
            {(field) => (
              <>
              <StringField
                label="Email"
                placeholder="Enter email..."
                value={field.value}
                error={field.error}
                onChange={field.onChange}
              />
              </>
            )}
          </FormField>
        </>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Cancel
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Next
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
